export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-tools@2x-efe8bc126de8064bf15678e289a4b8a4.png";